import { ReactElement, ReactNode } from 'react';
import { Box, Paper, Typography } from '@mui/material';

interface InfoCardProps {
  title: string;
  children: ReactNode;
  icon?: ReactElement;
  elevation?: number;
  border?: boolean;
  hoverEffect?: boolean;
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  children,
  icon,
  elevation = 2,
  border = true,
  hoverEffect = false,
}) => {
  return (
    <Paper
      elevation={elevation}
      sx={{
        p: 3,
        borderRadius: 2,
        height: '100%',
        transition: '0.2s',
        ...(border && {
          border: '1px solid',
          borderColor: 'divider',
        }),
        ...(hoverEffect && {
          '&:hover': {
            boxShadow: 4,
            transform: 'translateY(-2px)',
          },
        }),
      }}
    >
      <Box display="flex" alignItems="center" mb={2}>
        {icon && (
          <Box
            sx={{
              color: 'primary.main',
              mr: 1,
              '& .MuiSvgIcon-root': {
                fontSize: 24,
              },
            }}
          >
            {icon}
          </Box>
        )}
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
      </Box>
      <Box>{children}</Box>
    </Paper>
  );
};

export default InfoCard;
